import { render, staticRenderFns } from "./AudioPodcastElementSettings.vue?vue&type=template&id=7dc496c1&scoped=true&"
import script from "./AudioPodcastElementSettings.vue?vue&type=script&lang=ts&"
export * from "./AudioPodcastElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc496c1",
  null
  
)

export default component.exports